"use strict";
import _ from "underscore";
import CarrierService from "../services/carrier_service";
import Account from "../api/account";
const carrier_term = Account.carrierTerm();
var Carriers = {
  abbreviatedNames: function(carriers) {
    var names = _.pluck(carriers, "name");
    var start = _.first(names);
    if (names.length === 0) {
      return "Unknown " + carrier_term;
    } else if (names.length === 1) {
      return start;
    } else if (names.length === 2) {
      return start + " and 1 other";
    } else {
      var count = names.length - 1;
      return start + " and " + count + " others";
    }
  },
  nameAndInfoForId: function(carrierId) {
    var carrier = CarrierService.getCarrierOrUnknown(carrierId);
    var output = carrier.name;
    if (carrier.mc_number) {
      output += " - MC# ";
      output += carrier.mc_number;
    }
    if (carrier.ein) {
      output += " - EIN ";
      output += carrier.ein;
    }
    if (carrier.scac) {
      output += " - SCAC ";
      output += carrier.scac;
    }
    return output;
  }
};
export default Carriers;
